// extracted by mini-css-extract-plugin
export default {"list":"styles_list__m1Rsk","header":"styles_header__FRmu0","text":"styles_text__vhQmf"};